"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var normalizr_1 = require("normalizr");
exports.annotation = new normalizr_1.schema.Entity('annotations', {}, {
    processStrategy: function (value) {
        if (value.contentsByAnnotationId) {
            value.contentsByAnnotationId = value.contentsByAnnotationId.nodes;
        }
        return value;
    },
});
exports.appointment = new normalizr_1.schema.Entity('appointments');
exports.article = new normalizr_1.schema.Entity('articles', {}, {
    processStrategy: function (value) {
        if (value.contentsByArticleId) {
            value.contentsByArticleId = value.contentsByArticleId.nodes;
        }
        return value;
    },
});
exports.assertion = new normalizr_1.schema.Entity('assertions', {}, {
    processStrategy: function (value) {
        if (value.contentsByAssertionId) {
            value.contentsByAssertionId = value.contentsByAssertionId.nodes;
        }
        return value;
    },
});
exports.assignment = new normalizr_1.schema.Entity('assignments', {}, {
    processStrategy: function (value) {
        if (value.repliesByAssignmentId) {
            value.repliesByAssignmentId = value.repliesByAssignmentId.nodes;
            value.numberOfReplies = value.repliesByAssignmentId.totalCount;
        }
        return value;
    },
});
exports.board = new normalizr_1.schema.Entity('boards', {}, {
    processStrategy: function (value) {
        if (value.boardsKnowledgesByBoardId)
            value.boardsKnowledgesByBoardId = value.boardsKnowledgesByBoardId.nodes;
        if (value.boardsTeachersByBoardId)
            value.boardsTeachersByBoardId = value.boardsTeachersByBoardId.nodes;
        if (value.boardsDegreesByBoardId)
            value.boardsDegreesByBoardId = value.boardsDegreesByBoardId.nodes;
        if (value.materialsByBoardId)
            value.materialsByBoardId = value.materialsByBoardId.nodes;
        if (value.boardSectionsByBoardId)
            value.boardSectionsByBoardId = value.boardSectionsByBoardId.nodes;
        if (value.readingsByBoardId)
            value.readingsByBoardId = value.readingsByBoardId.nodes;
        if (value.ltreeKnowledgeAssociationsByBoardId)
            value.knowledgeAssociationsByBoardId = value.ltreeKnowledgeAssociationsByBoardId.nodes;
        return value;
    },
});
exports.boardsClassroom = new normalizr_1.schema.Entity('boardsClassrooms');
exports.boardsTeacher = new normalizr_1.schema.Entity('boardsTeachers', {}, {
    processStrategy: function (value) {
        var teacherByTeacherId = value.teacherByTeacherId;
        return __assign(__assign({}, value), { teacherByTeacherId: teacherByTeacherId });
    },
});
exports.boardsDegree = new normalizr_1.schema.Entity('boardsDegrees');
exports.boardSection = new normalizr_1.schema.Entity('boardSections', {}, {
    processStrategy: function (value) {
        if (value.materialsByBoardSectionsId)
            value.materialsByBoardSectionId = value.materialsByBoardSectionsId.nodes;
        return value;
    },
});
exports.boardsKnowledge = new normalizr_1.schema.Entity('boardsKnowledges', {}, {
    processStrategy: function (value) {
        var knowledgeByKnowledgeId = value.ltreeKnowledgeByKnowledgeId;
        return __assign(__assign({}, value), { knowledgeByKnowledgeId: knowledgeByKnowledgeId });
    },
});
exports.city = new normalizr_1.schema.Entity('cities');
exports.channel = new normalizr_1.schema.Entity('channel');
exports.classroom = new normalizr_1.schema.Entity('classrooms', {}, {
    processStrategy: function (value) {
        if (value.boardsClassroomsByClassroomId)
            value.boardsClassroomsByClassroomId = value.boardsClassroomsByClassroomId.nodes;
        if (value.staffByClassroomId)
            value.staffByClassroomId = value.staffByClassroomId.nodes;
        if (value.stoppedLists)
            value.stoppedLists = value.stoppedLists.nodes;
        if (value.popularLists)
            value.popularLists = value.popularLists.nodes;
        if (value.associatedLists)
            value.associatedLists = value.associatedLists.nodes;
        if (value.providerAssociationsByClassroomId)
            value.providerAssociationsByClassroomId = value.providerAssociationsByClassroomId.nodes;
        if (value.enrollmentsByClassroomId)
            value.enrollmentsByClassroomId = value.enrollmentsByClassroomId.nodes;
        if (value.appointmentsByClassroomId)
            value.appointmentsByClassroomId = value.appointmentsByClassroomId.nodes;
        if (value.materialsByClassroomId)
            value.materialsByClassroomId = value.materialsByClassroomId.nodes;
        return value;
    },
});
exports.comment = new normalizr_1.schema.Entity('comments', {}, {
    processStrategy: function (value) {
        if (value.contentsByCommentId && value.contentsByCommentId.nodes) {
            value.contentsByCommentId = value.contentsByCommentId.nodes;
        }
        if (value.exerciseCommentAttachmentsByCommentId && value.exerciseCommentAttachmentsByCommentId.nodes) {
            value.exerciseCommentAttachmentsByCommentId = value.exerciseCommentAttachmentsByCommentId.nodes;
        }
        return value;
    },
});
exports.exerciseCommentAttachments = new normalizr_1.schema.Entity('exerciseCommentAttachments');
exports.commentForum = new normalizr_1.schema.Entity('commentList');
exports.content = new normalizr_1.schema.Entity('contents');
exports.contract = new normalizr_1.schema.Entity('contracts');
exports.correction = new normalizr_1.schema.Entity('corrections', {}, {
    processStrategy: function (value) {
        if (value.correctionScoresByCorrectionId) {
            value.correctionScoresByCorrectionId = value.correctionScoresByCorrectionId.nodes;
        }
        return value;
    },
});
exports.correctionCriteria = new normalizr_1.schema.Entity('correctionCriterias');
exports.correctionScore = new normalizr_1.schema.Entity('correctionScores', {}, {
    processStrategy: function (value) {
        if (value.annotationsByCorrectionScoreId) {
            value.annotationsByCorrectionScoreId = value.annotationsByCorrectionScoreId.nodes;
        }
        return value;
    },
});
exports.course = new normalizr_1.schema.Entity('courses');
exports.degree = new normalizr_1.schema.Entity('degrees', {}, {
    processStrategy: function (value) {
        if (value.boardsDegreesByDegreeId)
            value.boardsDegreesByDegreeId = value.boardsDegreesByDegreeId.nodes;
        return value;
    },
});
exports.enrollment = new normalizr_1.schema.Entity('enrollments');
exports.essayReply = new normalizr_1.schema.Entity('essay_replies', {}, {
    processStrategy: function (value) {
        if (value.contentsByEssayReplyId) {
            value.contentsByEssayReplyId = value.contentsByEssayReplyId.nodes;
        }
        if (value.correctionsByEssayReplyId) {
            value.correctionsByEssayReplyId = value.correctionsByEssayReplyId.nodes;
        }
        return value;
    },
});
exports.exam = new normalizr_1.schema.Entity('exams', {}, {
    processStrategy: function (value) {
        if (value.assignmentsByExamId)
            value.assignmentsByExamId = value.assignmentsByExamId.nodes;
        return value;
    },
});
exports.examApplication = new normalizr_1.schema.Entity('examApplications');
exports.examinationBoard = new normalizr_1.schema.Entity('examinationBoards');
exports.examGroup = new normalizr_1.schema.Entity('examGroups', {}, {
    processStrategy: function (value) {
        if (value.materialsByExamGroupId) {
            value.materialsByExamGroupId = value.materialsByExamGroupId.nodes;
        }
        if (value.examGroupsExamsByExamGroupId) {
            value.examGroupsExamsByExamGroupId = value.examGroupsExamsByExamGroupId.nodes;
            value.examCount = value.examGroupsExamsByExamGroupId.totalCount;
        }
        return value;
    },
});
exports.examGroupsExam = new normalizr_1.schema.Entity('examGroupsExams');
exports.examMode = new normalizr_1.schema.Entity('exam_modes', {}, {
    processStrategy: function (value) {
        if (value.questionsByExamModeId) {
            value.questionsByExamModeId = value.questionsByExamModeId.nodes;
        }
        return value;
    },
});
exports.examQuestion = new normalizr_1.schema.Entity('examQuestions');
exports.forumSummary = new normalizr_1.schema.Entity('channels');
exports.image = new normalizr_1.schema.Entity('images');
exports.institution = new normalizr_1.schema.Entity('institutions');
exports.knowledge = new normalizr_1.schema.Entity('knowledges', {}, {
    processStrategy: function (value) {
        if (value.lists) {
            value.lists = value.lists.nodes;
        }
        if (value.ltreeKnowledgesByParentId) {
            value.ltreeKnowledgesByParentId = value.ltreeKnowledgesByParentId.nodes;
        }
        if (value.ltreeKnowledgeAssociationsByLtreeKnowledgeId) {
            value.ltreeKnowledgeAssociationsByLtreeKnowledgeId = value.ltreeKnowledgeAssociationsByLtreeKnowledgeId.nodes;
            value.numberOfAssociations = value.ltreeKnowledgeAssociationsByLtreeKnowledgeId.totalCount;
        }
        if (value.parents) {
            value.parents = value.parents.nodes;
        }
        return value;
    },
});
exports.knowledgeAssociation = new normalizr_1.schema.Entity('knowledgeAssociations', {}, {
    processStrategy: function (value) {
        var knowledgeByKnowledgeId = value.ltreeKnowledgeByLtreeKnowledgeId;
        return __assign(__assign({}, value), { knowledgeByKnowledgeId: knowledgeByKnowledgeId });
    },
});
exports.list = new normalizr_1.schema.Entity('lists', {}, {
    processStrategy: function (value) {
        if (value.listItemsByListId)
            value.listItemsByListId = value.listItemsByListId.nodes;
        if (value.repliesByListId)
            value.repliesByListId = value.repliesByListId.nodes;
        if (value.completedBy) {
            value.timesCompleted = value.completedBy.totalCount;
            value.completedBy = value.completedBy.nodes;
        }
        return value;
    },
});
exports.listItem = new normalizr_1.schema.Entity('listItems', {}, {
    processStrategy: function (value) {
        if (value.progressesByListItemId)
            value.progressesByListItemId = value.progressesByListItemId.nodes;
        return value;
    },
});
exports.listSession = new normalizr_1.schema.Entity('listSessions');
exports.live = new normalizr_1.schema.Entity('lives');
exports.material = new normalizr_1.schema.Entity('materials');
exports.offer = new normalizr_1.schema.Entity('offers');
exports.pipeline = new normalizr_1.schema.Entity('pipelines', {}, {
    processStrategy: function (value) {
        if (value.tasksByPipelineId)
            value.tasksByPipelineId = value.tasksByPipelineId.nodes;
        if (value.offersByPipelineId)
            value.offersByPipelineId = value.offersByPipelineId.nodes;
        return value;
    },
});
exports.pipelineRun = new normalizr_1.schema.Entity('pipelineRuns');
exports.progress = new normalizr_1.schema.Entity('progresses');
exports.provider = new normalizr_1.schema.Entity('providers');
exports.providerAssociation = new normalizr_1.schema.Entity('providerAssociations');
exports.question = new normalizr_1.schema.Entity('questions', {}, {
    processStrategy: function (value) {
        if (value.assertionsByQuestionId)
            value.assertionsByQuestionId = value.assertionsByQuestionId.nodes;
        if (value.contentsByQuestionId)
            value.contentsByQuestionId = value.contentsByQuestionId.nodes;
        if (value.solutionsByQuestionId)
            value.solutionsByQuestionId = value.solutionsByQuestionId.nodes;
        if (value.commentsByQuestionId)
            value.commentsByQuestionId = value.commentsByQuestionId.nodes;
        if (value.materialsByQuestionId)
            value.materialsByQuestionId = value.materialsByQuestionId.nodes;
        if (value.essayRepliesByQuestionId)
            value.essayRepliesByQuestionId = value.essayRepliesByQuestionId.nodes;
        if (value.examQuestionsByQuestionId)
            value.examQuestionsByQuestionId = value.examQuestionsByQuestionId.nodes;
        if (value.ltreeKnowledgeAssociationsByQuestionId)
            value.ltreeKnowledgeAssociationsByQuestionId = value.ltreeKnowledgeAssociationsByQuestionId.nodes;
        if (value.questionApplicationsByQuestionId)
            value.questionApplicationsByQuestionId = value.questionApplicationsByQuestionId.nodes;
        return value;
    },
});
exports.questionApplication = new normalizr_1.schema.Entity('questionApplications');
exports.reading = new normalizr_1.schema.Entity('readings');
exports.reply = new normalizr_1.schema.Entity('replies');
exports.role = new normalizr_1.schema.Entity('roles');
exports.school = new normalizr_1.schema.Entity('schools', {}, {
    processStrategy: function (value) {
        if (value.listsBySchoolId) {
            value.listsBySchoolId = value.listsBySchoolId.nodes;
        }
        return value;
    },
});
exports.solution = new normalizr_1.schema.Entity('solutions', {}, {
    processStrategy: function (value) {
        if (value.contentsBySolutionId) {
            value.contentsBySolutionId = value.contentsBySolutionId.nodes;
        }
        return value;
    },
});
exports.reaction = new normalizr_1.schema.Entity('reactions', {}, { idAttribute: 'contentId' });
exports.staff = new normalizr_1.schema.Entity('staffs');
exports.teacher = new normalizr_1.schema.Entity('teachers');
exports.state = new normalizr_1.schema.Entity('states');
exports.task = new normalizr_1.schema.Entity('tasks');
exports.text = new normalizr_1.schema.Entity('texts');
exports.topic = new normalizr_1.schema.Entity('topicList');
exports.user = new normalizr_1.schema.Entity('users', {}, {
    processStrategy: function (value) {
        if (value.contractsByUserId) {
            value.contractsByUserId = value.contractsByUserId.nodes;
        }
        if (value.disciplines) {
            value.disciplines = value.disciplines.nodes;
        }
        if (value.enrollmentsByUserId) {
            value.enrollmentsByUserId = value.enrollmentsByUserId.nodes;
        }
        if (value.startedEnrollments) {
            value.startedEnrollments = value.startedEnrollments.nodes;
        }
        if (value.pipelineRunsByUserId) {
            value.pipelineRunsByUserId = value.pipelineRunsByUserId.nodes;
        }
        if (value.listsByUserId) {
            value.listsByUserId = value.listsByUserId.nodes;
        }
        if (value.providerAssociationsByUserId) {
            value.providerAssociationsByUserId = value.providerAssociationsByUserId.nodes;
        }
        if (value.schools) {
            value.schools = value.schools.nodes;
        }
        if (value.staffByUserId) {
            value.staffByUserId = value.staffByUserId.nodes;
        }
        return value;
    },
});
exports.video = new normalizr_1.schema.Entity('videos');
exports.annotation.define({
    contentsByAnnotationId: [exports.content],
});
exports.appointment.define({
    liveByLiveId: exports.live,
    classroomByClassroomId: exports.classroom,
});
exports.article.define({
    contentsByArticleId: [exports.content],
});
exports.assertion.define({
    userByUserId: exports.user,
    contentsByAssertionId: [exports.content],
});
exports.assignment.define({
    userByUserId: exports.user,
    examByExamId: exports.exam,
});
exports.board.define({
    boardsDegreesByBoardId: [exports.boardsDegree],
    boardsKnowledgesByBoardId: [exports.boardsKnowledge],
    boardsTeachersByBoardId: [exports.boardsTeacher],
    boardSectionsByBoardId: [exports.boardSection],
    articleByStudyCaseId: exports.article,
    materialsByBoardId: [exports.material],
    readingsByBoardId: [exports.reading],
    knowledgeAssociationsByBoardId: [exports.knowledgeAssociation],
});
exports.boardsClassroom.define({
    boardByBoardId: exports.board,
});
exports.boardsDegree.define({
    degreeByDegreeId: exports.degree,
    boardByBoardId: exports.board,
});
exports.boardSection.define({
    materialsByBoardSectionId: [exports.material],
});
exports.boardsKnowledge.define({
    knowledgeByKnowledgeId: exports.knowledge,
});
exports.boardsTeacher.define({
    teacherByTeacherId: exports.teacher,
});
exports.channel.define({
    topicList: [exports.topic],
});
exports.city.define({
    stateByStateId: exports.state,
});
exports.classroom.define({
    boardsClassroomsByClassroomId: [exports.boardsClassroom],
    popularLists: [exports.list],
    stoppedLists: [exports.list],
    associatedLists: [exports.list],
    materialsByClassroomId: [exports.material],
    staffByClassroomId: [exports.staff],
    appointmentsByClassroomId: [exports.appointment],
    providerAssociationsByClassroomId: [exports.providerAssociation],
});
exports.commentForum.define({
    author: exports.user,
});
exports.content.define({
    textByTextId: exports.text,
    videoByVideoId: exports.video,
    imageByImageId: exports.image,
});
exports.contract.define({
    courseByCourseId: exports.course,
    userByUserId: exports.user,
});
exports.correction.define({
    correctionScoresByCorrectionId: [exports.correctionScore],
    essayReplyByEssayReplyId: exports.essayReply,
});
exports.correctionCriteria.define({
    ltreeKnowledgeByKnowledgeId: exports.knowledge,
});
exports.correctionScore.define({
    annotationsByCorrectionScoreId: [exports.annotation],
    ltreeKnowledgeByKnowledgeId: exports.knowledge,
    correctionCriteriaByCorrectionCriteriaId: exports.correctionCriteria,
});
exports.degree.define({
    boardsDegreesByDegreeId: [exports.boardsDegree],
});
exports.enrollment.define({
    classroomByClassroomId: exports.classroom,
    userByUserId: exports.user,
});
exports.essayReply.define({
    contentsByEssayReplyId: [exports.content],
    correctionsByEssayReplyId: [exports.correction],
    questionByQuestionId: exports.question,
});
exports.exam.define({
    assignmentsByExamId: [exports.assignment],
});
exports.examApplication.define({
    institutionByInstitutionId: exports.institution,
    examinationBoardByExaminationBoardId: exports.examinationBoard,
});
exports.examGroup.define({
    examGroupsExamsByExamGroupId: [exports.examGroupsExam],
    materialsByExamGroupId: [exports.material],
});
exports.examGroupsExam.define({
    examGroupByExamGroupId: exports.examGroup,
    examByExamId: exports.exam,
});
exports.examMode.define({
    questionsByExamModeId: [exports.question],
});
exports.examQuestion.define({
    examByExamId: exports.exam,
});
exports.knowledge.define({
    lists: [exports.list],
    ltreeKnowledgeAssociationsByLtreeKnowledgeId: [exports.knowledgeAssociation],
    ltreeKnowledgeByParentId: exports.knowledge,
    ltreeKnowledgesByParentId: [exports.knowledge],
    parents: [exports.knowledge],
});
exports.knowledgeAssociation.define({
    knowledgeByKnowledgeId: exports.knowledge,
});
exports.list.define({
    completedBy: [exports.user],
    listItemsByListId: [exports.listItem],
    repliesByListId: [exports.reply],
    schoolBySchoolId: exports.school,
});
exports.listItem.define({
    questionByQuestionId: exports.question,
    articleByArticleId: exports.article,
    videoByVideoId: exports.video,
    progressesByListItemId: [exports.progress],
});
exports.listSession.define({
    userByUserId: exports.user,
    listByListId: exports.list,
});
exports.material.define({
    boardByBoardId: exports.board,
    boardSectionByBoardSectionsId: exports.boardSection,
    listByListId: exports.list,
    questionByQuestionId: exports.question,
});
exports.offer.define({
    courseByCourseId: exports.course,
    pipelineByPipelineId: exports.pipeline,
});
exports.pipeline.define({
    tasksByPipelineId: [exports.task],
    pipelineByNextPipelineId: exports.pipeline,
    offersByPipelineId: [exports.offer],
});
exports.pipelineRun.define({
    taskByCurrentTaskId: exports.task,
    pipelineByPipelineId: exports.pipeline,
});
exports.progress.define({
    userByUserId: exports.user,
    listItemByListItemId: exports.listItem,
});
exports.providerAssociation.define({
    providerByProviderId: exports.provider,
    userByUserId: exports.user,
});
exports.question.define({
    assertionsByQuestionId: [exports.assertion],
    bestVotedSolution: exports.solution,
    contentsByQuestionId: [exports.content],
    essayRepliesByQuestionId: [exports.essayReply],
    examApplicationByExamApplicationId: exports.examApplication,
    examModeByExamModeId: exports.examMode,
    examQuestionsByQuestionId: [exports.examQuestion],
    ltreeKnowledgeAssociationsByQuestionId: [exports.knowledgeAssociation],
    materialsByQuestionId: [exports.material],
    questionApplicationsByQuestionId: [exports.questionApplication],
    solutionsByQuestionId: [exports.solution],
    commentsByQuestionId: [exports.comment],
    userByUserId: exports.user,
});
exports.questionApplication.define({
    questionByQuestionId: exports.question,
    examApplicationByExamApplicationId: exports.examApplication,
});
exports.reply.define({
    listByListId: exports.list,
    questionByQuestionId: exports.question,
});
exports.school.define({
    cityByCityId: exports.city,
    listsBySchoolId: [exports.list],
});
exports.solution.define({
    contentsBySolutionId: [exports.content],
    userByUserId: exports.user,
});
exports.comment.define({
    contentsByCommentId: [exports.content],
    exerciseCommentAttachmentsByCommentId: [exports.exerciseCommentAttachments],
    userByUserId: exports.user,
});
exports.staff.define({
    roleByRoleId: exports.role,
    userByUserId: exports.user,
    classroomByClassroomId: exports.classroom,
});
exports.task.define({
    pipelineByPipelineId: exports.pipeline,
});
exports.topic.define({
    commentList: [exports.commentForum],
    author: exports.user,
});
exports.user.define({
    contractsByUserId: [exports.contract],
    disciplines: [exports.knowledge],
    enrollmentsByUserId: [exports.enrollment],
    startedEnrollments: [exports.enrollment],
    listsByUserId: [exports.list],
    pipelineRunsByUserId: [exports.pipelineRun],
    providerAssociationsByUserId: [exports.providerAssociation],
    schools: [exports.school],
    staffByUserId: [exports.staff],
});
